import { httpClient, ApiResponse } from '@/utils';
import { IUsersListResponse, IUpdateUserDTO, UsersEndpoints, IGetUsersListDTO, IUser } from '@/models/users.model';
import omit from 'lodash.omit';

class UsersAPI {
  static getUsersList(data: IGetUsersListDTO): ApiResponse<IUsersListResponse> {
    return httpClient.get<IUsersListResponse>(UsersEndpoints.USERS_LIST, { params: data });
  }

  static getUserDetails(id: string): ApiResponse<IUser> {
    return httpClient.get<IUser>(`${UsersEndpoints.USERS}/${id}`);
  }

  static deleteUser(id: string): ApiResponse<IUser> {
    return httpClient.delete<IUser>(`${UsersEndpoints.USERS}/${id}`);
  }

  static updateUserDetails(data: IUpdateUserDTO): ApiResponse<IUser> {
    return httpClient.post<IUser>(`${UsersEndpoints.USERS}/${data?.id}`, omit({ ...data }, 'id'));
  }

  static activateUser(id: string): ApiResponse<IUser> {
    return httpClient.post<IUser>(`${UsersEndpoints.USERS}/${id}/activate`);
  }

  static deactivateUser(id: string): ApiResponse<IUser> {
    return httpClient.post<IUser>(`${UsersEndpoints.USERS}/${id}/deactivate`);
  }
}

export default UsersAPI;
